import { render, staticRenderFns } from "./remarkBox.vue?vue&type=template&id=2e31a5dd&"
import script from "./remarkBox.vue?vue&type=script&lang=js&"
export * from "./remarkBox.vue?vue&type=script&lang=js&"
import style0 from "./remarkBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports